import { memo, useEffect, useState } from 'react';

// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import useAuth from 'hooks/useAuth';
// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const { user } = useAuth();
    const [page, setPage] = useState('user');

    useEffect(() => {
        switch (user.role_id) {
            case 1:
                setPage('superAdmin');
                break;
            case 2:
                setPage('adminItems');
                break;
            case 3:
                setPage('trademakItems');
                break;
            default:
                setPage('user');
                break;
        }
    }, []);

    const navItems = menuItem[page].map((item) => {
        const currentItem = { ...item };

        if (currentItem.id === 'trademarkPages') {
            const isSpecialClient = user?.email === 'nestle@gmail.com' && user?.role?.name === 'Client';

            if (isSpecialClient) {
                // Special client sees ONLY 'area-covered'
                currentItem.children = currentItem.children.filter((child) => child.id);
            } else {
                // Everyone else does NOT see 'area-covered'
                currentItem.children = currentItem.children.filter((child) => child.id !== 'area-covered');
            }
        }

        switch (currentItem.type) {
            case 'group':
                return <NavGroup key={currentItem.id} item={currentItem} />;
            default:
                return (
                    <Typography key={currentItem.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default memo(MenuList);
